const STORAGE_KEY = 'pi-schedule:last-institution-url-endpoint';

/** Matches SchoolSettings / Welcome normalization: lowercase, digits, hyphens. */
function isValidEndpoint(value) {
    return typeof value === 'string' && /^[a-z0-9-]+$/.test(value);
}

export function getLastInstitutionUrlEndpoint() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        const v = (raw || '').trim().toLowerCase();
        return isValidEndpoint(v) ? v : null;
    } catch {
        return null;
    }
}

export function setLastInstitutionUrlEndpoint(endpoint) {
    try {
        const v = (endpoint || '').trim().toLowerCase();
        if (isValidEndpoint(v)) {
            localStorage.setItem(STORAGE_KEY, v);
        }
    } catch {
        // ignore quota / private mode
    }
}

export function clearLastInstitutionUrlEndpoint() {
    try {
        localStorage.removeItem(STORAGE_KEY);
    } catch {
        // ignore
    }
}
